import { Flex } from '@mantine/core';
import type { ReactNode } from 'react';
import React from 'react';

import { Text } from '~/domains/design-system/Text';

import useStyles from '../ContestCard.styles';
import type { ContestCardActionBanner } from '../types';

type ContestCardFooterMetaProps = {
  meta: {
    value: string;
    label: string | ReactNode;
    valueColor?: string;
    span?: number;
    textAlign?: string;
  }[];
  actionBanner: ContestCardActionBanner;
};

function ContestCardFooterMeta({ meta, actionBanner }: ContestCardFooterMetaProps) {
  const { classes } = useStyles({
    actionBannerColor: actionBanner?.color,
  });

  if (!meta || meta.length === 0) return null;

  const filteredMeta = meta.filter(Boolean);
  return (
    <Flex w="100%" justify="space-between">
      {filteredMeta.map(({ value, label, valueColor, textAlign = 'flex-start' }) => (
        <Flex
          direction="column"
          key={`${label}-${value}`}
          align={textAlign}
          style={{ minWidth: 0, flex: filteredMeta.length === 3 ? 1 : undefined }}
        >
          <Text tag="div" variant="body-small" className={classes.infoItemValue} c={valueColor}>
            {value}
          </Text>
          <Text tag="div" variant="body-small" c="gray.6" className={classes.infoItemLabel}>
            {label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}

export default ContestCardFooterMeta;
